// extracted by mini-css-extract-plugin
export var circle = "_ap-1";
export var exitConfirmationModal = "_ap-5";
export var iframe = "_ap-0";
export var offline = "_ap-3";
export var online = "_ap-2";
export var workstationSelectError = "_ap-4";